<template>
  <div>
    <el-dialog :visible.sync="isShown" :title="title" width="80%" @close="handleClose">
      <div>
        <el-form v-model="form" label-width="150px" ref="form">
          <el-form-item label="点検種別" prop="classification">
            <el-select v-model="form.classification">
              <el-option label="法定点検" value="法定点検" />
              <el-option label="修理" value="修理" />
              <el-option label="車検" value="車検" />
            </el-select>
          </el-form-item>
          <el-form-item label="時間">
            <el-time-select
              placeholder="開始時間"
              v-model="form.startTime"
              :picker-options="{
                start: '09:00',
                end: '22:00',
                step: '00:10',
              }">
            </el-time-select>
            <el-time-select
              placeholder="終了時間"
              v-model="form.endTime"
              :picker-options="{
                start: '09:00',
                end: '22:00',
                step: '00:10',
                minTime: form.startTime,
              }">
            </el-time-select>

          </el-form-item>
          <el-form-item label="車両名" prop="name">
            <el-input v-model="form.name" placeholder="車両名"></el-input>
          </el-form-item>
          <el-form-item label="対応ディーラー" prop="dealerId">
            <el-select v-model="form.dealerId" @change="fetchLiftData">
              <el-option
                v-for="dealer in dealers"
                :key="dealer.id"
                :label="dealer.name"
                :value="dealer.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="リフト" prop="liftId">
            <el-select v-model="form.liftId">
              <el-option label="未割り当て" :value="null">
              </el-option>
              <el-option
                v-for="lift in lifts"
                :key="lift.id"
                :label="lift.name"
                :value="lift.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="顧客名" prop="customer">
            <el-input v-model="form.customer" placeholder="顧客名"></el-input>
          </el-form-item>
          <el-form-item label="メカニック" prop="mechanic">
            <el-input v-model="form.mechanic" placeholder="メカニック"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="success" @click="submit">{{ this.id ? '更新' : '作成' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import {reservationData, dealerData, liftData} from '@/mock'

export default {
  name: 'ReservationModal',
  props: {
    dealerId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      id: null,
      isShown: false,
      dealers: [],
      lifts: [],
      form: {
        liftId: null,
        name: null,
        dealerId: null,
        mechanic: null,
        customer: null,
        classification: '',
        startAt: null,
        endAt: null,
        startTime: null,
        endTime: null,
      },
    }
  },
  computed: {
    title () {
      return this.id ? '編集' : '作成'
    },
  },
  methods: {
    show (reservationId, tick, liftId) {
      this.id = reservationId
      if (this.id) {
        this.fetchReservationData()
        this.fetchLiftData()
      } else {
        this.form.startAt = moment().seconds(0).millisecond(0)
        this.form.endAt = moment().seconds(0).millisecond(0)
        this.form.startTime = tick.format('HH:mm')
        this.form.endTime = tick.add(2, 'hours').format('HH:mm')
        this.form.liftId = liftId
        this.form.dealerId = this.dealerId
      }
      this.isShown = true
    },
    fetchDealerData () {
      this.dealers = dealerData
    },
    fetchReservationData () {
      let data = reservationData.find(x => x.id === this.id)
      Object.keys(this.form).forEach(key => {
        if (data[key] === undefined) {
          return true
        }
        this.form[key] = data[key]
      })
      let tmp = moment(this.form.startAt)
      this.form['startTime'] = tmp.format('HH:mm')

      tmp = moment(this.form.endAt)
      this.form['endTime'] = tmp.format('HH:mm')
    },
    fetchLiftData () {
      let ret = liftData.filter(x => x.dealerId === this.form.dealerId)
      if (!ret.find(x => x.id === this.form.liftId)) {
        this.form.liftId = null
      }
      this.lifts = ret
    },
    submit () {
      let data = {...this.form}
      let tmp = /(\d+):(\d+)/g.exec(this.form.startTime)
      data['startAt'] = moment(this.form.startAt).hours(tmp[1]).minutes(tmp[2]).toISOString()
      tmp = /(\d+):(\d+)/g.exec(this.form.endTime)
      data['endAt'] = moment(this.form.startAt).hours(tmp[1]).minutes(tmp[2]).toISOString()
      if (this.id) {
        data['id'] = this.id
        let obj = reservationData.find(x => x.id === this.id)
        Object.keys(obj).forEach(x => {
          obj[x] = data[x]
        })
      } else {
        let id = Math.max.apply(null, reservationData.map(x => x.id))
        data['id'] = id + 1
        reservationData.push(data)
      }
      this.$emit('updated')
      this.handleClose()
    },
    reset () {
      this.id = null
      this.$refs.form.resetFields()
    },
    handleClose () {
      this.reset()
      this.isShown = false
    },
  },
  mounted () {
    this.fetchDealerData()
    this.fetchLiftData()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Modal.vue